import { ApolloQueryResult } from '@apollo/client/core/types';
import { useSidebar } from '@css-xp/base';
import { BillingAdmin, CommerceAddress } from '@css-xp/graphtypes';
import React from 'react';
import EditBillingDetailsForm from './edit-billing-details-form';
import { CreditCard } from '@css-xp/graphtypes/src/generated-types-new';

/**
 * This component is required to pass closeSidebar to the form. calling useSidebar
 * directly on the calling page causes continuous re-rendering
 * */

export interface EditBillingDetails {
  transactionAccountId?: string;
  billToAddress?: CommerceAddress | null;
  shipToAddress?: CommerceAddress | null;
  displayName?: string | null;
  invoiceGroupId?: string;
  billToPartyPricingEligibilty?: string | null;
  billingAdmins?: (BillingAdmin | undefined | null)[];
  isShipToAddressViewable?: boolean | true;
  onComplete: () => Promise<ApolloQueryResult<unknown>>;
  billToAddressHeading?: string;
  availablePaymentMethods?: CreditCard[];
  isPartner?: boolean;
}
export const EditBillingDetailsSidebar = ({ ...props }: EditBillingDetails) => {
  const { closeSidebar, reopenMostRecentSidebar } = useSidebar();

  return (
    <div>
      <EditBillingDetailsForm
        {...props}
        isShipToAddressViewable={false}
        onComplete={props.onComplete}
        onClose={closeSidebar}
      />
    </div>
  );
};
